export const DEFAULT_GROUP_SLUG = 'brands';
